/* Hazari Impex inner pages (20 Oct 2026): folds long product descriptions and FAQ answers, adds a buy bar on phones, helps when a search finds nothing.
   Each part runs only on the page it belongs to and does nothing if the page is not shaped as expected. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }

  /* ---- product: a description without headings becomes one "Description" section, cut short with Read more when long ---- */
  function oneDescription(d) {
    if (d.getAttribute('data-hz') || !d.textContent.trim()) return;
    var acc = el('div', 'hz-acc');
    var det = el('details');
    det.open = true;
    det.appendChild(el('summary', '', 'Description'));
    var body = el('div', 'hz-acc-body');
    while (d.firstChild) body.appendChild(d.firstChild);
    det.appendChild(body);
    acc.appendChild(det);
    d.appendChild(acc);
    d.setAttribute('data-hz', '1');
    var btn = null;
    function measure() {
      if (btn || body.scrollHeight <= 400) return;
      body.classList.add('hz-clip');
      btn = el('button', 'hz-readmore', 'Read more');
      btn.type = 'button';
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('open');
        btn.textContent = open ? 'Show less' : 'Read more';
      });
      det.appendChild(btn);
    }
    measure();
    setTimeout(measure, 700);
  }

  /* ---- product: fold the description by its headings ---- */
  function foldDescription() {
    var d = $('.product__description');
    if (!d || d.getAttribute('data-hz')) return;
    var heads = $$('h2', d);
    if (!heads.length) { oneDescription(d); return; }
    var host = heads[0].parentElement;
    if (heads.some(function (h) { return h.parentElement !== host; })) return;
    var groups = [{ t: 'Description', n: [] }];
    var cur = groups[0];
    [].slice.call(host.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'H2') { cur = { t: n.textContent.replace(/\s+/g, ' ').trim(), n: [] }; groups.push(cur); return; }
      if (n.nodeType === 3 && !n.textContent.trim()) return;
      if (n.nodeType === 1 && (n.tagName === 'HR' || (n.querySelector('hr') && !n.textContent.trim()))) return;
      cur.n.push(n);
    });
    groups = groups.filter(function (g) { return g.n.length; });
    if (groups.length < 2) { oneDescription(d); return; }
    var acc = el('div', 'hz-acc');
    groups.forEach(function (g, i) {
      var det = el('details');
      if (i === 0) det.open = true;
      var body = el('div', 'hz-acc-body');
      g.n.forEach(function (n) { body.appendChild(n); });
      det.appendChild(el('summary', '', g.t));
      det.appendChild(body);
      acc.appendChild(det);
    });
    host.innerHTML = '';
    host.appendChild(acc);
    d.setAttribute('data-hz', '1');
  }

  /* ---- product: buy bar that follows the customer on a phone ---- */
  function stickyBuy() {
    var btn = $('.product-form__submit');
    var info = $('.product__info-container');
    if (!btn || !info || $('.hz-sticky')) return;
    var bar = el('div', 'hz-sticky');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Buy');
    var sp = el('div', 'hz-sp');
    var pb = el('b');
    var ps = el('s');
    sp.appendChild(pb); sp.appendChild(ps);
    var bt = el('button');
    bt.type = 'button';
    bar.appendChild(sp); bar.appendChild(bt);
    document.body.appendChild(bar);
    document.body.classList.add('hz-has-sticky');
    function sync() {
      var onSale = !!$('.price--on-sale', info);
      var now = onSale ? $('.price-item--sale', info) : $('.price__regular .price-item--regular', info);
      var was = onSale ? $('.price--on-sale s.price-item', info) : null;
      pb.textContent = now ? now.textContent.replace(/\s+/g, ' ').trim() : '';
      ps.textContent = was ? was.textContent.replace(/\s+/g, ' ').trim() : '';
      var off = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      bt.disabled = off;
      bt.textContent = off ? (btn.textContent.replace(/\s+/g, ' ').trim() || 'Sold out') : 'Add to Cart';
    }
    sync();
    new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });
    bt.addEventListener('click', function () { if (!btn.disabled) btn.click(); });
    var queued = false;
    function place() {
      queued = false;
      var r = btn.getBoundingClientRect();
      var on = r.bottom < 0;
      bar.classList.toggle('on', on);
      document.body.classList.toggle('hz-bar-on', on);
    }
    function onScroll() { if (!queued) { queued = true; requestAnimationFrame(place); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    place();
  }

  /* ---- FAQ: each question folds ---- */
  function foldFaq() {
    if (!/\/pages\/faq/.test(location.pathname)) return;
    var rte = $('main .rte');
    if (!rte || rte.getAttribute('data-hz')) return;
    var kids = [].slice.call(rte.children);
    if (!kids.some(function (k) { return k.tagName === 'H3'; })) return;
    var out = [];
    var det = null;
    kids.forEach(function (k) {
      if (k.tagName === 'H3') {
        det = el('details');
        det.appendChild(el('summary', '', k.textContent.replace(/\s+/g, ' ').trim()));
        det.appendChild(el('div', 'hz-acc-body'));
        out.push(det);
      } else if (k.tagName === 'H2') { det = null; out.push(k); }
      else if (det) { $('.hz-acc-body', det).appendChild(k); }
      else out.push(k);
    });
    rte.innerHTML = '';
    var box = null;
    out.forEach(function (n) {
      if (n.tagName === 'DETAILS') {
        if (!box) { box = el('div', 'hz-acc hz-faq'); rte.appendChild(box); }
        box.appendChild(n);
      } else { box = null; rte.appendChild(n); }
    });
    var first = $('details', rte);
    if (first) first.open = true;
    rte.setAttribute('data-hz', '1');
  }

  /* ---- search: nothing found ---- */
  function helpEmptySearch() {
    if (!/\/search/.test(location.pathname) || $('.hz-nores')) return;
    var txt = ($('main') || document.body).innerText || '';
    if (!/no results found/i.test(txt) || $('main .card-wrapper')) return;
    var box = el('div', 'hz-nores');
    box.appendChild(el('p', '', 'Or browse a category:'));
    var chips = el('div', 'hz-chips');
    [['Camping gear', '/collections/hiking-camping-equipments'], ['Luggage and travel', '/collections/luggage-sets'], ['Baby and mother care', '/collections/feeding-bottles-utensils'], ['Cleaning', '/collections/cleaning-liquids-dispenser'], ['Tools and hardware', '/collections/diy'], ['Kitchen knives', '/collections/kitchen-knifes'], ['All brands', '/pages/brands']].forEach(function (c) {
      var a = el('a', '', c[0]); a.href = c[1]; chips.appendChild(a);
    });
    box.appendChild(chips);
    // put it right under the "No results found" sentence
    var note = null;
    $$('main p, main div, main span').forEach(function (n) {
      if (!note && n.children.length === 0 && /no results found/i.test(n.textContent)) note = n;
    });
    if (note && note.parentNode) note.parentNode.insertBefore(box, note.nextSibling);
    else ($('main') || document.body).appendChild(box);
  }

  /* ---- collections without a main heading get one (it is hidden, the banner already shows the name) ---- */
  function ensureHeading() {
    if (!/^\/collections\/[^/]+\/?$/.test(location.pathname) || $('h1')) return;
    var crumb = $('.breadcrumbs__item:last-child .breadcrumbs__link');
    var name = crumb ? crumb.textContent.replace(/\s+/g, ' ').trim() : document.title.split('–')[0].trim();
    var h = el('h1', 'visually-hidden', name);
    var main = $('main') || document.body;
    main.insertBefore(h, main.firstChild);
  }


  /* ---- one main heading per page: extra h1 tags inside written content become h2 ---- */
  function ensureSingleH1() {
    var hs = $$('h1');
    if (hs.length < 2) return;
    var keep = null;
    hs.forEach(function (h) { if (!keep && !h.closest('.rte, .shopify-policy__body, .product__description')) keep = h; });
    if (!keep) keep = hs[0];
    hs.forEach(function (h) {
      if (h === keep) return;
      var n = document.createElement('h2');
      [].slice.call(h.attributes).forEach(function (a) { n.setAttribute(a.name, a.value); });
      n.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(n, h);
    });
  }

  /* ---- collection and search breadcrumbs: the last crumb is bare text, so wrap it to let a long name end with "..." ---- */
  function crumbEnd() {
    var li = $('.breadcrumbs__list-top .breadcrumbs__item:last-child');
    if (!li || li.querySelector('a, span, .hz-crumb-text')) return;
    var txt = null;
    [].slice.call(li.childNodes).forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) txt = n; });
    if (!txt) return;
    var s = el('span', 'hz-crumb-text', txt.textContent.replace(/\s+/g, ' ').trim());
    li.replaceChild(s, txt);
  }


  /* =====================================================================
     Product page extras (21 Oct 2026): brand line, "You save" line, colour pictures, photo counter, folded reviews
     ===================================================================== */
  var _prod = null;
  function productData() {
    var m = location.pathname.match(/^\/products\/([^/?#]+)/);
    if (!m) return Promise.resolve(null);
    if (!_prod) {
      _prod = fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return _prod;
  }
  function money(n) { return 'Rs.' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function digits(t) { var d = (t || '').replace(/[^\d]/g, ''); return d ? parseInt(d, 10) : 0; }

  /* brand name above the title (not for the catch-all "Made In China") */
  function brandLine() {
    var title = $('.product__info-container .product__title');
    if (!title || $('.hz-brand')) return;
    productData().then(function (p) {
      if (!p || !p.vendor || /^made in china$/i.test(p.vendor) || $('.hz-brand')) return;
      var a = el('a', 'hz-brand', p.vendor);
      a.href = '/collections/vendors?q=' + encodeURIComponent(p.vendor);
      title.parentNode.insertBefore(a, title);
    });
  }

  /* "You save Rs.11,000" under the price, kept in step with the chosen variant.
     When a product's options carry different old prices (one Kamiliant suitcase: Rs.46,000 and Rs.47,500) the theme marks the page "on sale" but draws no old price,
     so the old price of the chosen option is drawn from the product data (22 Oct 2026, found by the audit of every product page). */
  function saveLine() {
    var info = $('.product__info-container');
    if (!info || info.getAttribute('data-hz-save')) return;
    info.setAttribute('data-hz-save', '1');
    var pdata = null;
    function chosen() {
      var f = $('form[action*="/cart/add"] input[name="id"]');
      var id = f ? parseInt(f.value, 10) : 0, v = null;
      if (pdata && pdata.variants) pdata.variants.forEach(function (x) { if (x.id === id) v = x; });
      return v;
    }
    function oldPrice() {
      var sale = $('.price--on-sale .price__sale', info);
      var was = $('.price--on-sale s.price-item', info);
      if (!sale || (was && digits(was.textContent) > 0)) return;
      var v = chosen();
      var cmp = v && v.compare_at_price ? v.compare_at_price / 100 : 0;
      var pr = v ? v.price / 100 : 0;
      if (!(cmp > pr)) return;
      var s = $('.hz-fixed-was', sale);
      if (!s) { s = el('s', 'price-item price-item--regular hz-fixed-was'); sale.appendChild(s); }
      if (s.textContent !== money(cmp)) s.textContent = money(cmp);
    }
    function sync() {
      oldPrice();
      var now = $('.price--on-sale .price-item--sale', info);
      var was = $('.price--on-sale s.price-item', info);
      var box = $('.hz-save', info);
      var d = now && was ? digits(was.textContent) - digits(now.textContent) : 0;
      if (d > 0) {
        var t = 'You save ' + money(d);
        if (!box) {
          box = el('div', 'hz-save');
          var anchor = $('[id^="price-template"]', info) || $('.price', info);
          if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling);
        }
        if (box && box.textContent !== t) box.textContent = t;
      } else if (box) { box.remove(); }
    }
    sync();
    productData().then(function (p) { pdata = p; sync(); });
    new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true });
  }

  /* colour choices carry the picture of that colour */
  function colourPictures() {
    if (!$('variant-selects')) return;
    productData().then(function (p) {
      if (!p || !p.options || !p.variants) return;
      var pos = -1;
      p.options.forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (pos < 0 && /colou?r/i.test(n || '')) pos = i; });
      if (pos < 0) return;
      var map = {};
      p.variants.forEach(function (v) {
        var val = v['option' + (pos + 1)];
        var img = v.featured_image && v.featured_image.src;
        if (val && img && !map[val]) map[val] = img;
      });
      function apply() {
        $$('variant-selects fieldset').forEach(function (fs) {
          var leg = $('legend', fs);
          if (!leg || !/colou?r/i.test(leg.textContent)) return;
          $$('input[type=radio]', fs).forEach(function (inp) {
            var lab = fs.querySelector('label[for="' + inp.id + '"]');
            var src = map[inp.value];
            if (!lab || !src || lab.querySelector('.hz-sw')) return;
            var im = el('img', 'hz-sw');
            im.alt = ''; im.width = 28; im.height = 28; im.loading = 'lazy';
            im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=64';
            lab.insertBefore(im, lab.firstChild);
          });
        });
      }
      apply();
      var vs = $('variant-selects');
      if (vs) new MutationObserver(apply).observe(vs, { childList: true, subtree: true });
    });
  }

  /* "1 / 9" on the big picture, counted from the small pictures (the theme moves the picked picture to the front of its list) */
  function photoCounter() {
    var wrap = $('.product__media-wrapper');
    if (!wrap || $('.hz-count')) return;
    var list = $('.product__media-list', wrap);
    if (!list) return;
    function thumbs() { return $$('.thumbnail-slider .thumbnail, .thumbnail-list .thumbnail', wrap); }
    if (thumbs().length < 2 && $$('.product__media-item', wrap).length < 2) return;
    var host = list.parentNode;
    var box = el('div', 'hz-count');
    box.setAttribute('aria-hidden', 'true');
    host.appendChild(box);
    function sync() {
      var t = thumbs();
      var n = t.length, i = -1;
      if (n >= 2) {
        t.forEach(function (x, k) { if (i < 0 && (x.getAttribute('aria-current') === 'true' || x.classList.contains('is-active'))) i = k; });
      } else {
        var all = $$('.product__media-item', wrap);
        n = all.length;
        all.forEach(function (x, k) { if (i < 0 && x.classList.contains('is-active')) i = k; });
      }
      var txt = (i < 0 ? 1 : i + 1) + ' / ' + n;
      if (box.textContent !== txt) box.textContent = txt;
    }
    sync();
    new MutationObserver(sync).observe(wrap, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-current'] });
  }

  /* customer reviews fold away; the Judge.me widget loads late, so look for it for a few seconds */
  function foldReviews() {
    var tries = 0;
    (function look() {
      var w = $('#judgeme_product_reviews') || $('.jdgm-rev-widg');
      var sec = w && w.closest('.shopify-section');
      // never fold a section that holds the product itself (the small star badge also uses a Judge.me class)
      if (sec && (sec.querySelector('product-info, form[action*="/cart/add"], .product-form__submit') || /main/i.test(sec.id || ''))) return;
      if (sec && !sec.getAttribute('data-hz-fold')) {
        sec.setAttribute('data-hz-fold', '1');
        var txt = (sec.innerText || '');
        var m = txt.match(/based on (\d+) review/i);
        var d = el('details', 'hz-fold');
        d.appendChild(el('summary', '', 'Customer reviews' + (m ? ' (' + m[1] + ')' : '')));
        var body = el('div', 'hz-fold-body');
        while (sec.firstChild) body.appendChild(sec.firstChild);
        d.appendChild(body);
        sec.appendChild(d);
        return;
      }
      if (!sec && ++tries < 14) setTimeout(look, 600);
    })();
  }

  /* SKU back in the Description section (client request, 21 Oct 2026), following the chosen colour or size.
     The theme's own SKU line stays hidden; products with no SKU show nothing. */
  function skuLine() {
    var info = $('.product__info-container');
    if (!info || info.getAttribute('data-hz-sku')) return;
    info.setAttribute('data-hz-sku', '1');
    productData().then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      function chosen() {
        var inp = $('form[action*="/cart/add"] input[name="id"]');
        var id = inp ? parseInt(inp.value, 10) : 0;
        if (!id) { var m = location.search.match(/[?&]variant=(\d+)/); id = m ? parseInt(m[1], 10) : 0; }
        for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i];
        return p.variants[0];
      }
      function sync() {
        var det = $('.product__description .hz-acc details');
        if (!det) return;
        var v = chosen();
        var sku = v && v.sku ? String(v.sku).trim() : '';
        var row = $('.hz-sku', det);
        if (!sku) { if (row) row.remove(); return; }
        var t = 'SKU: ' + sku;
        if (!row) {
          row = el('p', 'hz-sku');
          det.insertBefore(row, $('.hz-acc-body', det) || null);
        }
        if (row.textContent !== t) row.textContent = t;
      }
      sync();
      new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true });
      document.addEventListener('change', function () { setTimeout(sync, 300); });
    });
  }

  function productExtras() {
    if (!/^\/products\//.test(location.pathname)) return;
    try { skuLine(); } catch (e) { /* leave the page as it was */ }
    try { brandLine(); } catch (e) { /* leave the page as it was */ }
    try { saveLine(); } catch (e) { /* leave the page as it was */ }
    try { colourPictures(); } catch (e) { /* leave the page as it was */ }
    try { photoCounter(); } catch (e) { /* leave the page as it was */ }
    try { foldReviews(); } catch (e) { /* leave the page as it was */ }
  }

  /* =====================================================================
     "Popular right now": a row of in-stock best sellers for the empty cart and for searches that find nothing
     ===================================================================== */
  var _pop = null;
  function popularData() {
    if (!_pop) {
      _pop = fetch('/collections/best-sellers/products.json?limit=16', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    }
    return _pop;
  }
  function popularRow(host, heading) {
    if (!host || $('.hz-pop', host)) return;
    popularData().then(function (ps) {
      if ($('.hz-pop', host)) return;
      ps = ps.filter(function (p) {
        return p.images && p.images.length && p.variants.some(function (v) { return v.available; });
      }).slice(0, 6);
      if (ps.length < 3) return;
      var box = el('section', 'hz-pop');
      box.appendChild(el('h2', '', heading || 'Popular right now'));
      var row = el('div', 'hz-pop-row');
      ps.forEach(function (p) {
        var prices = p.variants.filter(function (v) { return v.available; }).map(function (v) { return parseFloat(v.price); });
        var a = el('a', 'hz-pop-card');
        a.href = '/products/' + p.handle;
        var im = el('img');
        var src = p.images[0].src;
        im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=320';
        im.alt = ''; im.loading = 'lazy'; im.width = 160; im.height = 160;
        a.appendChild(im);
        a.appendChild(el('span', 'hz-pop-t', p.title));
        a.appendChild(el('b', 'hz-pop-p', (prices.length > 1 && Math.min.apply(null, prices) !== Math.max.apply(null, prices) ? 'From ' : '') + money(Math.min.apply(null, prices))));
        row.appendChild(a);
      });
      box.appendChild(row);
      host.appendChild(box);
    });
  }

  /* =====================================================================
     Cart page (21 Oct 2026): item count in the title, note folded, delivery line, buy bar on phones, popular products when empty
     ===================================================================== */
  function cartPage() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    var wrap = $('cart-items');
    if (!wrap) return;
    var bar = null;

    function itemCount() {
      var n = 0;
      $$('.cart-item input.quantity__input').forEach(function (i) { n += parseInt(i.value, 10) || 0; });
      return n;
    }
    function apply() {
      var n = itemCount();
      var title = $('.cart-wrapper__title');
      if (title) {
        var s = $('.hz-sub', title);
        if (n > 0) {
          var t = ' (' + n + (n === 1 ? ' item' : ' items') + ')';
          if (!s) { s = el('span', 'hz-sub', t); title.appendChild(s); } else if (s.textContent !== t) { s.textContent = t; }
        } else if (s) { s.remove(); }
      }
      // note folded away until needed
      var note = $('cart-note');
      if (note && !note.closest('.hz-note')) {
        var d = el('details', 'hz-note');
        d.appendChild(el('summary', '', 'Add a note to your order'));
        note.parentNode.insertBefore(d, note);
        d.appendChild(note);
      }
      // delivery line
      var totals = $('.cart__blocks .totals');
      if (totals && !$('.hz-del', totals.parentNode)) {
        var line = el('div', 'hz-del');
        line.appendChild(el('span', '', 'Delivery'));
        line.appendChild(el('span', '', 'Shown at checkout'));
        totals.parentNode.insertBefore(line, totals.nextSibling);
      }
      // empty cart: show popular products
      var empty = wrap.classList.contains('is-empty') || n === 0;
      if (empty) popularRow($('.cart__warnings, .cart-wrapper .page-width') || wrap, 'Popular right now');
      syncBar();
    }
    function syncBar() {
      var out = $('#checkout');
      if (!out || itemCount() === 0) { if (bar) bar.classList.remove('on'); return; }
      if (!bar) {
        bar = el('div', 'hz-cartbar');
        bar.setAttribute('role', 'region');
        bar.setAttribute('aria-label', 'Check out');
        var sp = el('div', 'hz-sp');
        sp.appendChild(el('span', '', 'Total'));
        sp.appendChild(el('b'));
        var bt = el('button'); bt.type = 'button'; bt.textContent = 'Check out';
        bt.addEventListener('click', function () { var o = $('#checkout'); if (o) o.click(); });
        bar.appendChild(sp); bar.appendChild(bt);
        document.body.appendChild(bar);
        document.body.classList.add('hz-has-cartbar');
        window.addEventListener('scroll', place, { passive: true });
        window.addEventListener('resize', place);
      }
      var tv = $('.totals__total-value, .totals__subtotal-value');
      var b = $('b', bar);
      var txt = tv ? tv.textContent.replace(/\s+/g, ' ').replace(/\s*PKR$/i, '').trim() : '';
      if (b && b.textContent !== txt) b.textContent = txt;
      place();
    }
    function place() {
      if (!bar) return;
      var o = $('#checkout');
      var r = o ? o.getBoundingClientRect() : null;
      var on = !!r && (r.top > window.innerHeight - 10 || r.bottom < 0);
      bar.classList.toggle('on', on);
      document.body.classList.toggle('hz-bar-on', on);
    }
    apply();
    window.addEventListener('load', place);
    if (window.ResizeObserver) new ResizeObserver(place).observe(document.body);
    setTimeout(place, 800);
    setTimeout(place, 2500);
    new MutationObserver(function () { apply(); }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  /* =====================================================================
     Collection pages (21 Oct 2026): sub-category chips, filter bar that stays on screen, "Showing 12 of N" with Show more,
     and the Filter and sort sheet (sort list, Clear all, Show N products)
     ===================================================================== */
  function collectionHandle() {
    var m = location.pathname.match(/^\/collections\/([^/]+)\/?$/);
    return m && m[1] !== 'vendors' ? m[1] : null;
  }

  /* chips: the other collections in the same menu group (for example Back Packs, Duffle Bags, Luggage Sets) */
  function collectionChips() {
    var h = collectionHandle();
    var aside = $('#main-collection-filters');
    if (!h || !aside || $('.hz-chiprow')) return;
    var sel = '.header__inline-menu a[href="/collections/' + h + '"], .menu-drawer a[href="/collections/' + h + '"]';
    var picked = null;
    $$(sel).forEach(function (a) {
      if (picked) return;
      var ul = a.closest('ul');
      var det = ul && ul.closest('details');
      var sum = det && $('summary', det);
      var label = sum ? sum.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!ul || !det || /^(brands|all categories|new arrival)$/i.test(label)) return;
      var seen = {};
      var items = $$('a[href^="/collections/"]', ul).filter(function (x) { var k = x.getAttribute('href'); if (seen[k]) return false; seen[k] = 1; return true; });
      if (items.length >= 2 && items.length <= 14) picked = { label: label, items: items };
    });
    if (!picked) return;
    var nav = el('nav', 'hz-chiprow');
    nav.setAttribute('aria-label', 'More in ' + picked.label);
    picked.items.forEach(function (x) {
      var c = el('a', 'hz-chip', x.textContent.replace(/\s+/g, ' ').trim());
      c.href = x.getAttribute('href');
      if (x.getAttribute('href') === '/collections/' + h) { c.className += ' is-current'; c.setAttribute('aria-current', 'page'); }
      nav.appendChild(c);
    });
    // phone and laptop: the chips sit in the same sticky row as the Filter button and the product count, so they stay on screen while scrolling
    // (26 Oct 2026: the laptop got the same row); only if the row is missing do they take a line of their own above the products
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
    function place() {
      var inBar = $('.facets-container', aside);
      if (inBar) { if (nav.parentNode !== inBar) inBar.appendChild(nav); }
      else if (nav.parentNode !== aside.parentNode) aside.parentNode.insertBefore(nav, aside);
    }
    function showCurrent() { var cur = $('.is-current', nav); if (!cur || nav.scrollWidth <= nav.clientWidth) return; var a = nav.getBoundingClientRect(), c = cur.getBoundingClientRect(); nav.scrollLeft = Math.max(0, nav.scrollLeft + (c.left - a.left) - (a.width - c.width) / 2); }
    place();
    setTimeout(showCurrent, 150); setTimeout(showCurrent, 900);
    function onChange() { place(); setTimeout(showCurrent, 60); }
    if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
  }

  /* the Filter and Sort bar stays under the header while the customer scrolls the products (phone) */
  function stickyFacets() {
    var bar = $('#main-collection-filters') || $('#main-search-filters');
    if (!bar || bar.getAttribute('data-hz-sticky')) return;
    bar.setAttribute('data-hz-sticky', '1');
    bar.classList.add('hz-sticky-bar');
    var hdr = $('sticky-header') || $('header');
    var queued = false;
    function place() {
      queued = false;
      var r = hdr ? hdr.getBoundingClientRect() : { bottom: 0 };
      bar.style.top = Math.max(0, Math.round(r.bottom)) + 'px';
    }
    function on() { if (!queued) { queued = true; requestAnimationFrame(place); } }
    window.addEventListener('scroll', on, { passive: true });
    window.addEventListener('resize', on);
    place();
  }

  /* phone: one sticky row = Filter and Sort icon button, product count, category chips (22 Oct 2026, owner: icon only, and the chips and count must not disappear while scrolling).
     The count and a small badge with the number of active filters are kept in step when filters change. */
  function barCount() {
    var box = $('#main-collection-filters .facets-container') || $('#main-search-filters .facets-container');
    if (!box) return;
    var src = $('.mobile-facets__count') || $('.product-count');
    var m = ((src && src.textContent) || '').match(/\d[\d,]*/);
    var span = $('.hz-bar-count', box);
    if (!m) { if (span) span.remove(); }
    else {
      var num = m[0], label = num === '1' ? 'product' : 'products';
      if (!span) {
        span = el('span', 'hz-bar-count');
        span.appendChild(el('b', '', num));
        span.appendChild(el('small', '', label));
        var wrap = $('.mobile-facets__wrapper', box);
        box.insertBefore(span, wrap ? wrap.nextSibling : box.firstChild);
      } else {
        var b = $('b', span), s = $('small', span);
        if (b && b.textContent !== num) b.textContent = num;
        if (s && s.textContent !== label) s.textContent = label;
      }
    }
    var open = $('.mobile-facets__open-wrapper', box);
    if (open) {
      if (open.getAttribute('aria-label') !== 'Filter and sort') open.setAttribute('aria-label', 'Filter and sort');
      var holder = $('.mobile-facets__open', open);
      var wide = window.matchMedia ? window.matchMedia('(min-width: 750px)').matches : false;
      var pills = $$('.active-facets-mobile facet-remove', box).filter(function (f) { return !f.classList.contains('active-facets__button-wrapper'); });
      // the theme adds the full price range (Rs.0 to the highest price) as a filter whenever the customer sorts or filters; on laptop that is not a real filter, so its pill
      // and the count on the Filter button leave it out (26 Oct 2026)
      var mxIn = $('input[name="filter.v.price.lte"]');
      var mx = mxIn ? parseInt(mxIn.getAttribute('max') || '0', 10) : 0;
      var n = 0;
      pills.forEach(function (f) {
        var m = f.textContent.replace(/\s+/g, ' ').match(/Rs\.?\s*0\s*-\s*Rs\.?\s*([\d,]+)/i);
        var full = !!(wide && m && mx && parseInt(m[1].replace(/,/g, ''), 10) >= mx);
        f.classList.toggle('hz-pill-full', full);
        if (!full) n++;
      });
      var row = $('.active-facets-mobile', box);
      if (row) row.setAttribute('data-hz-real', String(n));
      var badge = holder && $('.hz-filter-badge', holder);
      if (holder && n > 0) {
        if (!badge) { badge = el('span', 'hz-filter-badge'); holder.appendChild(badge); }
        if (badge.textContent !== String(n)) badge.textContent = String(n);
      } else if (badge) badge.remove();
    }
  }

  /* laptop and tablet: the Sort By list in the sticky row (26 Oct 2026). The page keeps its own Sort list (a set of radio buttons) in the product area and redraws it when
     products change, so the row holds a copy that mirrors its choices and presses the real one; the copy is rebuilt whenever the real list differs. Hidden on phones
     (the sheet has the sort list). */
  function barSort() {
    var box = $('#main-collection-filters .facets-container') || $('#main-search-filters .facets-container');
    var radios = $$('#FacetSortForm input[name="sort_by"]');
    if (!box || !radios.length) return;
    var wrap = $('.hz-bar-sort', box);
    if (!wrap) {
      wrap = el('div', 'hz-bar-sort');
      var lab = el('label', '', 'Sort By');
      var sel0 = el('select', 'hz-bar-sort-select');
      sel0.id = 'hz-bar-sort';
      lab.setAttribute('for', 'hz-bar-sort');
      wrap.appendChild(lab); wrap.appendChild(sel0);
      box.appendChild(wrap);
      sel0.addEventListener('change', function () {
        var r = $$('#FacetSortForm input[name="sort_by"]').filter(function (x) { return x.value === sel0.value; })[0];
        if (r) r.click();
      });
    }
    var sel = $('select', wrap);
    var sig = radios.map(function (r) { return r.value + '|' + r.parentNode.textContent.replace(/\s+/g, ' ').trim(); }).join('~');
    if (sel.getAttribute('data-sig') !== sig) {
      sel.innerHTML = '';
      radios.forEach(function (r) { var op = el('option', '', r.parentNode.textContent.replace(/\s+/g, ' ').trim()); op.value = r.value; sel.appendChild(op); });
      sel.setAttribute('data-sig', sig);
    }
    // the page marks the chosen sort on the list item (the radio buttons carry no checked attribute)
    var cur = radios.filter(function (r) { var li = r.closest('li'); return li && li.classList.contains('selected'); })[0] || radios.filter(function (r) { return r.checked; })[0];
    if (cur && sel.value !== cur.value) sel.value = cur.value;
  }

  /* first 36 products; the next 36 are added by themselves when the customer scrolls near the end of the list (lazy loading), up to 3 times in a row;
     then a "Show 36 more" button is a checkpoint (so the footer stays reachable on long lists) and one click gives 3 more automatic batches.
     A second page of products is fetched from the shop when the first runs out. 36 fills whole rows on a phone (2 across), tablet (3) and laptop (4). */
  function showMore() {
    var grid = $('#product-grid');
    if (!grid || grid.tagName !== 'UL' || grid.getAttribute('data-hz-more')) return;
    var FIRST = 36, STEP = 36, AUTO = 3;
    var canAuto = 'IntersectionObserver' in window;
    function liItems() { return $$(':scope > li', grid); }
    function nextOf(doc) {
      // the theme gives both arrows the class "next", so pick the one that says Next
      var arrows = $$('.pagination__item-arrow, .pagination__item--next', doc || document);
      var a = null;
      arrows.forEach(function (x) { if (!a && /next/i.test((x.getAttribute('aria-label') || '') + ' ' + x.textContent)) a = x; });
      var h = a && a.getAttribute('href');
      return h && !a.classList.contains('disabled') ? h : null;
    }
    var nextUrl = nextOf(document);
    if (liItems().length <= FIRST && !nextUrl) return;
    var cnt = ($('.product-count') || {}).textContent || '';
    var m = cnt.match(/(\d[\d,]*)/);
    var total = m ? parseInt(m[1].replace(/,/g, ''), 10) : liItems().length;
    grid.setAttribute('data-hz-more', '1');
    document.body.classList.add('hz-showmore');
    var shown = FIRST, autoLeft = AUTO, busy = false, isDone = false, io = null;
    var box = el('div', 'hz-more');
    var note = el('p', 'hz-more-note');
    var btn = el('button', 'hz-more-btn');
    btn.type = 'button';
    box.appendChild(note); box.appendChild(btn);
    grid.parentNode.insertBefore(box, grid.nextSibling);
    function render() {
      var all = liItems();
      all.forEach(function (li, i) { li.classList.toggle('hz-more-hide', i >= shown); });
      var visible = Math.min(shown, all.length);
      total = Math.max(total, all.length);
      note.textContent = busy ? 'Loading more products...' : 'Showing ' + visible + ' of ' + total;
      var left = total - visible;
      isDone = left <= 0 || (visible >= all.length && !nextUrl);
      // while lazy loading is in charge the button stays out of the way; it shows at the checkpoint, when lazy loading is not available, or when nothing was loaded
      btn.hidden = isDone || (canAuto && autoLeft > 0 && !busy);
      btn.disabled = busy;
      btn.textContent = busy ? 'Loading...' : 'Show ' + Math.min(STEP, Math.max(left, 0)) + ' more';
    }
    function fetchNext() {
      if (!nextUrl) return Promise.resolve();
      return fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('#product-grid');
          if (g) $$(':scope > li', g).forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          nextUrl = nextOf(doc);
        })
        .catch(function () { nextUrl = null; });
    }
    // bring in shop pages until `shown` products exist (a shop page can hold fewer than a full step)
    function fill() { return fetchNext().then(function () { return (shown > liItems().length && nextUrl) ? fill() : null; }); }
    function grow() {
      if (busy) return;
      shown += STEP;
      if (shown <= liItems().length || !nextUrl) { render(); watch(); return; }
      busy = true; render();
      fill().then(function () { busy = false; render(); watch(); });
    }
    function watch() {
      if (io) { io.disconnect(); io = null; }
      if (!canAuto || autoLeft <= 0 || isDone) return;
      io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting || busy || autoLeft <= 0 || isDone) return;
        autoLeft--;
        io.disconnect(); io = null;
        grow();
      }, { rootMargin: '800px 0px' });
      io.observe(box);
    }
    btn.addEventListener('click', function () { autoLeft = AUTO; grow(); });
    render();
    if (liItems().length < FIRST && nextUrl) {
      // the shop sends fewer than 36 on its first page: complete the first view now
      busy = true; render();
      fill().then(function () { busy = false; render(); watch(); });
    } else watch();
  }

  /* the Filter and sort sheet on a phone: sort choices as a list, Clear all, Show N products */
  function filterSheet() {
    var wrap = $('#FacetsWrapperMobile');
    if (!wrap) return;
    var sel = $('#SortBy-mobile', wrap) || $('select[name="sort_by"]', wrap);
    if (sel && !$('.hz-sortlist', wrap)) {
      var want = { 'manual': 'Featured', 'best-selling': 'Best selling', 'price-ascending': 'Price, low to high', 'price-descending': 'Price, high to low', 'created-descending': 'Newest first' };
      var fs = el('fieldset', 'hz-sortlist');
      fs.appendChild(el('legend', '', 'Sort by'));
      [].slice.call(sel.options).forEach(function (o) {
        if (!want[o.value]) return;
        var lab = el('label', 'hz-radio');
        var inp = el('input');
        inp.type = 'radio'; inp.name = 'hz-sort'; inp.value = o.value; inp.checked = o.selected;
        lab.appendChild(inp);
        lab.appendChild(el('span', '', want[o.value]));
        inp.addEventListener('change', function () { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); });
        fs.appendChild(lab);
      });
      wrap.insertBefore(fs, wrap.firstChild);
    }
    var count = $('.mobile-facets__count');
    $$('.mobile-facets__footer', wrap).forEach(function (f) {
      var clear = $('.mobile-facets__clear', f);
      if (clear && /^(remove all|clear)$/i.test(clear.textContent.trim())) clear.textContent = 'Clear all';
      var ap = $('button.button--primary span', f) || $('button.button--primary', f);
      if (ap && count) {
        var n = (count.textContent.match(/\d[\d,]*/) || ['0'])[0];
        var t = 'Show ' + n + (n === '1' ? ' product' : ' products');
        if (ap.textContent !== t && f.parentNode === wrap) ap.textContent = t;
      }
    });
  }

  function collectionPage() {
    if (!/^\/(collections|search)/.test(location.pathname)) return;
    try { collectionChips(); } catch (e) { /* leave the page as it was */ }
    try { stickyFacets(); } catch (e) { /* leave the page as it was */ }
    try { barCount(); } catch (e) { /* leave the page as it was */ }
    try { barSort(); } catch (e) { /* leave the page as it was */ }
    try { showMore(); } catch (e) { /* leave the page as it was */ }
    try { filterSheet(); } catch (e) { /* leave the page as it was */ }
    // filtering and sorting redraw parts of the page: put our pieces back
    var main = document.getElementById('MainContent');
    if (main && !main.getAttribute('data-hz-watch')) {
      main.setAttribute('data-hz-watch', '1');
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          try { if (!$('#product-grid[data-hz-more]')) showMore(); } catch (e) { /* leave */ }
          try { filterSheet(); } catch (e) { /* leave */ }
          try { barCount(); } catch (e) { /* leave */ }
          try { barSort(); } catch (e) { /* leave */ }
        }, 150);
      }).observe(main, { childList: true, subtree: true });
    }
  }

  /* =====================================================================
     "Item added to your cart" panel: add the cart total under the product (21 Oct 2026)
     ===================================================================== */
  function cartNotice() {
    var n = $('#cart-notification');
    if (!n || n.getAttribute('data-hz-watch')) return;
    n.setAttribute('data-hz-watch', '1');
    function addTotal() {
      if (!n.classList.contains('active')) return;
      var cs = $('.button-label', n);
      if (cs && /^continue shopping$/i.test(cs.textContent.trim()) && cs.textContent.trim() !== 'Continue shopping') cs.textContent = 'Continue shopping';
      $$('.cart-notification-product .caption-with-letter-spacing', n).forEach(function (c) { if (/^made in china$/i.test(c.textContent.trim())) c.style.display = 'none'; });
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var old = $('.hz-ntot', n);
        if (old) old.remove();
        var links = $('.cart-notification__links', n);
        if (!links || !c || !c.item_count) return;
        var row = el('div', 'hz-ntot');
        row.appendChild(el('span', '', 'Cart total (' + c.item_count + (c.item_count === 1 ? ' item' : ' items') + ')'));
        row.appendChild(el('b', '', money(c.total_price / 100)));
        links.parentNode.insertBefore(row, links);
      }).catch(function () { /* the panel still works without the total */ });
    }
    new MutationObserver(addTotal).observe(n, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function () { if (n.classList.contains('active') && !$('.hz-ntot', n)) addTotal(); }).observe($('#cart-notification-product') || n, { childList: true, subtree: true });
  }

  /* =====================================================================
     The round WhatsApp icon (a separate widget) steps aside while it would sit on a button or field,
     and comes back in the gaps, so it never blocks Add to Cart or a form (21 Oct 2026)
     ===================================================================== */
  function whatsappGuard() {
    var tries = 0;
    (function wait() {
      var w = $('#wfb-wrapper');
      if (w) { guardIcon(w); return; }
      if (++tries < 24) setTimeout(wait, 500);   // the widget is added to the page after it loads
    })();
  }
  function guardIcon(wa) {
    if (wa.getAttribute('data-hz-guard')) return;
    wa.setAttribute('data-hz-guard', '1');
    wa.style.transition = 'opacity .15s ease';
    var t = null;
    function check() {
      var r = wa.getBoundingClientRect();
      if (!r.width) return;
      var spots = [[0.2, 0.2], [0.8, 0.2], [0.5, 0.5], [0.2, 0.8], [0.8, 0.8]];
      var covers = spots.some(function (s) {
        var els = document.elementsFromPoint(r.left + r.width * s[0], r.top + r.height * s[1]);
        return els.some(function (e) {
          return !wa.contains(e) && e.closest && e.closest('button, input, select, textarea, summary, label, a.button, cart-remove-button, quantity-input, .hz-chip, .hz-pop-card, .hz-ask, .product-form__submit') && !e.closest('.hz-sticky, .hz-cartbar, #cart-notification');
        });
      });
      wa.style.opacity = covers ? '0' : '1';
      wa.style.pointerEvents = covers ? 'none' : '';
    }
    function later() { clearTimeout(t); t = setTimeout(check, 90); }
    window.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    window.addEventListener('touchend', later, { passive: true });
    check();
    setTimeout(check, 700);
    setTimeout(check, 2200);
  }
  /* =====================================================================
     Menu (21 Oct 2026): the Combo Deals pill and the Brands logos are found by the NAME of the menu item, not by its position,
     so changing the menu order can never move them (base.css used to style the 3rd, 4th and 6th items by position).
     No discount bubbles are drawn anywhere in the menu.
     ===================================================================== */
  var MENU_LOGOS = {
    'al-clean': 'hazari-brand-al-clean.png', 'autosol': 'hazari-brand-autosol.png', 'baby-magic': 'hazari-brand-baby-magic.png',
    'bosny': 'hazari-brand-bosny.png', 'campingaz': 'campingaz-logo.png', 'coghlans': 'Coghlans_new_logo.png',
    'coleman': 'Coleman_logo.png', 'comos': 'hazari-brand-comos.png', 'discovery-adventure': 'hazari-brand-discovery-adventure.png',
    'dukshin': 'hazari-brand-dukshin.png', 'fluxo': 'hazari-brand-fluxo.png', 'gerber': 'hazari-brand-gerber.png',
    'glo-flo': 'hazari-brand-glo-flo.png', 'histar': 'hazari-brand-histar.png', 'interflex': 'hazari-brand-interflex.png',
    'invicta': 'hazari-brand-invicta.png', 'justwell': 'JUSTWELL.png', 'kamiliant-luggage': 'kamiliant-logo.png',
    'kingcamp': 'hazari-brand-kingcamp.png', 'nuk': 'NUKLogo-01.png', 'oateo': 'hazari-brand-oateo.png',
    'philips': 'hazari-brand-philips.png', 'compas-powermints-sugar-free': 'hazari-brand-compass-powermints.png',
    'pro-camp': 'hazari-brand-pro-camp.png', 'pure-fishing': 'hazari-brand-pure-fishing.png', 'rahber': 'hazari-brand-rahber.png',
    'ruilang': 'hazari-brand-ruilang.png', 'rubbermaid': 'hazari-brand-rubbermaid.png',
    'rubbermaid-commercial': 'hazari-brand-rubbermaid-commercial.png', 'stanley': 'STANLEY.png', 'thermos': 'hazari-brand-thermos.png',
    'tigex': 'hazari-brand-tigex.png', 'tree-hut': 'hazari-brand-tree-hut.png'
  };
  function menuLogos() {
    $$('.menu-drawer__navigation > ul > li, .header__inline-menu > ul > li').forEach(function (li) {
      var head = li.querySelector('summary, a');
      var label = head ? head.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (label === 'combo deals') li.classList.add('hz-nav-combo');
      if (label !== 'brands') return;
      li.classList.add('hz-nav-brands');
      $$('ul li a', li).forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
        var f = m && MENU_LOGOS[m[1]];
        if (!f) return;
        a.style.setProperty('--hz-logo', 'url("/cdn/shop/files/' + f + '")');
        a.classList.add('hz-has-logo');
      });
    });
  }


  /* =====================================================================
     Search page and information pages (21 Oct 2026)
     ===================================================================== */
  function searchPage() {
    if (!/^\/search/.test(location.pathname)) return;
    document.body.classList.add('hz-search');
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    var nores = $('.hz-nores');
    if (nores) {
      // nothing found: a way to ask, and something to look at
      if (!$('.hz-ask', nores.parentNode)) {
        var a = el('a', 'hz-ask');
        a.href = 'https://wa.me/923308883031?text=' + encodeURIComponent('Hello Hazari Impex, I am looking for ' + (q ? '"' + q + '"' : 'a product') + '. Do you have it?');
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = "Can't find it? Ask us on WhatsApp 0330 8883031";
        nores.parentNode.insertBefore(a, nores.nextSibling);
        popularRow(nores.parentNode, 'Popular products');
      }
      return;
    }
    // results: a plain heading with the count instead of the big banner
    var cnt = $('.product-count');
    var m = cnt && cnt.textContent.match(/(\d[\d,]*)/);
    var host = $('.template-search');
    if (m && host && q && !$('.hz-search-title')) {
      var h = el('h2', 'hz-search-title', m[1] + (m[1] === '1' ? ' result' : ' results') + ' for “' + q + '”');
      host.insertBefore(h, host.firstChild);
    }
  }

  /* FAQ: chips that jump to each topic */
  function faqChips() {
    if (!/\/pages\/faq/.test(location.pathname)) return;
    document.body.classList.add('hz-page-faq');
    var rte = $('main .rte');
    if (!rte || $('.hz-chiprow', rte)) return;
    var hs = $$('h2', rte).filter(function (h) { return h.parentNode === rte; });
    if (hs.length < 2) return;
    var nav = el('nav', 'hz-chiprow');
    nav.setAttribute('aria-label', 'Jump to a topic');
    hs.forEach(function (h, i) {
      h.id = h.id || 'faq-' + (i + 1);
      var c = el('a', 'hz-chip', h.textContent.replace(/\s+/g, ' ').trim());
      c.href = '#' + h.id;
      nav.appendChild(c);
    });
    rte.insertBefore(nav, hs[0]);
  }

  /* Brands: a "Find a brand" box above the tiles */
  function brandsFind() {
    if (!/\/pages\/brands/.test(location.pathname)) return;
    document.body.classList.add('hz-brands');
    var grid = $('#hz-brands-grid');
    if (!grid || $('.hz-find')) return;
    var box = el('div', 'hz-find');
    var lab = el('label', 'visually-hidden', 'Find a brand');
    lab.setAttribute('for', 'hz-find-input');
    var inp = el('input');
    inp.id = 'hz-find-input'; inp.type = 'search'; inp.placeholder = 'Find a brand'; inp.autocomplete = 'off';
    var note = el('p', 'hz-find-note');
    note.setAttribute('aria-live', 'polite');
    box.appendChild(lab); box.appendChild(inp); box.appendChild(note);
    grid.parentNode.insertBefore(box, grid);
    function tiles() { return $$('li', grid); }
    function count() {
      var all = tiles();
      var n = all.filter(function (li) { return li.style.display !== 'none' && li.getBoundingClientRect().height > 0 || (li.style.display !== 'none' && !li.hidden); }).length;
      note.textContent = all.length === 0 ? '' : n === 0 ? 'No brand matches. Try a shorter name.' : n + (n === 1 ? ' brand' : ' brands') + (inp.value.trim() ? ' match' : '');
    }
    inp.addEventListener('input', function () {
      var q = inp.value.trim().toLowerCase();
      tiles().forEach(function (li) {
        var a = $('a', li);
        var name = ((a && (a.getAttribute('aria-label') || a.title)) || li.textContent).toLowerCase().replace(/ products$/, '');
        li.style.display = !q || name.indexOf(q) > -1 ? '' : 'none';
      });
      count();
    });
    new MutationObserver(count).observe(grid, { childList: true });
    count();
    setTimeout(count, 900);
  }

  /* Contact page: light layout, plainer wording, WhatsApp first */
  function contactPage() {
    if (!/\/pages\/contact-us/.test(location.pathname)) return;
    document.body.classList.add('hz-contact');
    var hero = $('.main-hero__inner');
    if (hero) {
      var t = $('.main-page-title', hero);
      if (t && /^contact us$/i.test(t.textContent.trim()) && t.textContent.trim() !== 'Contact us') t.textContent = 'Contact us';
      $$('p, div, span', hero).forEach(function (n) {
        if (n.children.length === 0 && /reach out to our team/i.test(n.textContent)) n.textContent = 'Ask about a product, an order or a bulk quote. We reply Monday to Saturday.';
      });
    }
    $$('.sv-card').forEach(function (c) {
      var lab = $('.sv-label', c);
      if (!lab) return;
      var t2 = lab.textContent.trim();
      if (t2 === 'Phone') lab.textContent = 'Call us';
      if (t2 === 'Our Store') lab.textContent = 'Visit the shop';
    });
    $$('a[href^="mailto:"] .sv-sub').forEach(function (n) { if (/24 hours/i.test(n.textContent)) n.textContent = 'We reply Monday to Saturday'; });
    var h2 = $('.form-wrapper .section-title');
    if (h2 && /get in touch/i.test(h2.textContent)) h2.textContent = 'Send a message';
  }
  function run() {
    try { ensureHeading(); } catch (e) { /* leave the page as it was */ }
    try { foldDescription(); } catch (e) { /* leave the page as it was */ }
    try { stickyBuy(); } catch (e) { /* leave the page as it was */ }
    try { foldFaq(); } catch (e) { /* leave the page as it was */ }
    try { ensureSingleH1(); } catch (e) { /* leave the page as it was */ }
    try { helpEmptySearch(); } catch (e) { /* leave the page as it was */ }
    try { productExtras(); } catch (e) { /* leave the page as it was */ }
    try { cartPage(); } catch (e) { /* leave the page as it was */ }
    try { collectionPage(); } catch (e) { /* leave the page as it was */ }
    try { searchPage(); } catch (e) { /* leave the page as it was */ }
    try { faqChips(); } catch (e) { /* leave the page as it was */ }
    try { brandsFind(); } catch (e) { /* leave the page as it was */ }
    try { contactPage(); } catch (e) { /* leave the page as it was */ }
    try { cartNotice(); } catch (e) { /* leave the page as it was */ }
    try { whatsappGuard(); } catch (e) { /* leave the page as it was */ }
    try { crumbEnd(); } catch (e) { /* leave the page as it was */ }
    try { menuLogos(); } catch (e) { /* leave the page as it was */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
